import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-develop",
  "use": "icon-develop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-develop\"><defs><style type=\"text/css\"></style></defs><path d=\"M529.0496 527.616l-30.7712-30.7456 85.0688-85.0944 30.7712 30.7712z\" p-id=\"2808\" fill=\"#cdcdcd\" /><path d=\"M0 340.48l427.52 256 248.32 427.52L1024 0l-1024 340.48zM665.6 921.6l-207.36-355.84-355.84-212.48L911.36 81.92l-243.2 243.2 30.72 30.72 243.2-243.2L665.6 921.6z\" p-id=\"2809\" fill=\"#cdcdcd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol